import windowTemplateUrl from './modal-window.html';
import templateUrl from './modal.html';

export class ModalService {
	constructor($uibModal) {
		'ngInject';

		this.$uibModal = $uibModal; 
	}
	open(details) {
		let _details = {
			component: details.component || 'modal',
			windowTemplateUrl: details.windowTemplateUrl || windowTemplateUrl,
			resolve: {
				details() {
					return details.details;
				},
				buttons() {
					return details.buttons;
				},
				templateUrl() {
					return details.templateUrl || templateUrl;
				}
			},
			size: details.size
		};
		var modalInstance = this.$uibModal.open(_details);
		modalInstance.result.catch((error) => {
	      	if(error === "backdrop click") {
	        	
	      	} else {
	        	throw error;
	      	}
	    });
	    return modalInstance;
	}
}

// Example to use
/*
	this.modalService.open({
		details: {
			bodyMessage: 'Body Message'
		},
		buttons: [{
			name: 'cancel',
			action() {
				console.log('cancelled');
			}
		}, {
			name: 'submit',
			isPrimary: true,
			action() {
				console.log('closed');
			}
		}]
	});
*/


// WEBPACK FOOTER //
// ./src/app/common/components/modal/modal.service.js